import { createApp } from 'vue'


import App from './App.vue'


import router from './router'



import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { createPinia } from 'pinia'


// createApp(App).mount('#app')


const pinia = createPinia()


const app = createApp(App)


app.use(router)
app.use(pinia)

app.use(ElementPlus,{
    locale:zhCn
})

app.mount('#app')
